import { useEffect } from "react";
import { editStorageObject } from "../../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import type { ResearchValue } from "../../../services/api/instances/researchApi/types";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { getEventLogAction, getResearchResultAction } from "../redux/actions";

export const useResearchPolling = () => {
  const dispatch = useAppDispatch();
  const { selectedId, selectedObject } = useStorageSelectors("research");

  useEffect(() => {
    if (!selectedId || !selectedObject?.value?.research_object?.run_id) {
      return;
    }
    let isPolling = true;
    let eventTimeoutId: ReturnType<typeof setTimeout> | null = null;
    let resultTimeoutId: ReturnType<typeof setTimeout> | null = null;
    const runId = selectedObject?.value?.research_object?.run_id;
    const pollEvents = async () => {
      if (!isPolling) return;
      try {
        await dispatch(getEventLogAction(runId)).unwrap();
      } catch (error) {
        console.warn("Event log polling error:", error);
      }
      if (isPolling) {
        eventTimeoutId = setTimeout(pollEvents, 1000);
      }
    };

    const pollResult = async () => {
      if (!isPolling) return;
      try {
        const result = await dispatch(getResearchResultAction(runId)).unwrap();
        if (result) {
          isPolling = false;
        }
      } catch (error) {
        if (isPolling && error === "Run not done yet") {
          resultTimeoutId = setTimeout(pollResult, 5000);
        } else {
          console.error("Result polling error:", error);
          isPolling = false;
        }
      }
    };

    pollEvents();
    pollResult();

    return () => {
      isPolling = false;
      if (eventTimeoutId) clearTimeout(eventTimeoutId);
      if (resultTimeoutId) clearTimeout(resultTimeoutId);
    };
  }, [selectedObject?.value?.research_object?.run_id, selectedId]);
};
